import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  SxProps,
  useTheme,
} from '@mui/material';
import { FC } from 'react';
import { IPlatform } from '../../shared/interfaces/IPlatform';
import { useTranslation } from 'react-i18next';

interface Props {
  disabled?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent) => void;
  platforms: IPlatform[];
  sx?: SxProps;
}

const PlatformSelect: FC<Props> = ({ disabled, value, onChange, platforms }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  // Sorted copy: the array is a prop and PlatformService hands out a module-level cached array.
  const sortedPlatforms = [...(platforms ?? [])].sort((a, b) =>
    a.name.localeCompare(b.name, 'de', { sensitivity: 'base' })
  );
  return (
    <FormControl
      disabled={disabled}
      size="small"
      sx={{ minWidth: '284px', my: theme.spacing(1) }}
    >
      <InputLabel id="platform-select-label">{t('platform')}</InputLabel>
      <Select
        labelId="platform-select-label"
        value={value}
        onChange={onChange}
        label={t('platform')}
      >
        <MenuItem value="">
          <em>-</em>
        </MenuItem>
        {sortedPlatforms.map(({ id, name, label }) => {
          return (
            <MenuItem
              value={label}
              key={id}
            >
              {name}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default PlatformSelect;
